const {connect} = require('react-redux');
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

const {formatText} = require('core/i18n').i18n;

const {
    requestBlockDevice,
    requestForgetDevice
} = require('actions/devices');
const { setBlockTrustedDeviceInfo } = require('actions/devicesBlockTrusted');

// @utilities
const { recordLink } = require("utilities/tagging");

const {PopoverMenu} = require('commonsComponents/popoverMenu');
const {OKButton} = require('components/commons/OKButton/OKButton');

// @constants
const {
    FETCH_DEVICES_CC_OPEN_MODAL_BLOCK,
    FETCH_DEVICES_CC_OPEN_MODAL_HIDE,
    FETCH_DEVICES_CC_OPEN_MODAL_SHOW,
    FETCH_DEVICES_CC_OPEN_MODAL_UNBLOCK
} = require('constants/contactCenter/actionTypes');

const { BLOCK_DEVICE_SECURITY, ENROL_DEVICES } = require("constants/flagBasedFeatures");

const {
    DEVICES_BLOCK,
    DEVICES_HIDE,
    DEVICES_INIT,
    DEVICES_SHOW,
} = require("constants/tagging.js");

class GridDevicesOptionsButton extends React.Component {

    changeEnrolDevice = (device) => {
        this.props.history.push(`/myprofile/devices/enrol/${device.sid}`);
    };

    changeForgetDevice = (device) => {
        const {forgotten} = device;
        const text = formatText(!forgotten ? "manageDevices-modalForgetText" : "manageDevices-modalRememberText")
        const title = formatText(!forgotten ? "manageDevices-modalForgetTitle" : "manageDevices-modalRememberTitle", [device.alias])
        const buttonText = formatText(!forgotten ? "manageDevices-modalForgetButton" : "manageDevices-modalRememberButton")
        // Contact Center Object: Wrapup and Print needs
        const ccExtraInfo = {
            action: !forgotten ? FETCH_DEVICES_CC_OPEN_MODAL_HIDE : FETCH_DEVICES_CC_OPEN_MODAL_SHOW,
            device: device.alias
        };
        const devicesTagging = !forgotten
            ? recordLink(DEVICES_HIDE, DEVICES_INIT)
            : recordLink(DEVICES_SHOW, DEVICES_INIT);
        const buttonAction = () => this.props.requestForgetDevice(device.sid, device.blocked, forgotten, ccExtraInfo.action)
        this.props.openModal(
            title,
            text,
            "",
            buttonText,
            "",
            buttonAction,
            {},
            devicesTagging,
        );
    };

    blockDevice = (device) => {
        const blockDeviceFlag = this.props.flagBasedFeatures.get(BLOCK_DEVICE_SECURITY);
        const { blocked, trusted } = device;
        let text = formatText(blocked ? "manageDevices-modalUnblockText" : "manageDevices-modalBlockText")
        let title = formatText(blocked ? "manageDevices-modalUnblockTitle" : "manageDevices-modalBlockTitle", [device.alias])
        const buttonText = formatText(blocked ? "manageDevices-modalUnblockButton" : "manageDevices-modalBlockButton")
        let secondaryText;
        let deviceName;

        const ccExtraInfo = {
            action: blocked ? FETCH_DEVICES_CC_OPEN_MODAL_UNBLOCK : FETCH_DEVICES_CC_OPEN_MODAL_BLOCK,
            device: device.alias
        };
        let buttonAction = () => this.props.requestBlockDevice(device.sid, !blocked, ccExtraInfo.action)

        if (!blocked && trusted && blockDeviceFlag) {
            text = formatText("manageDevices-modalBlockTextOneTrustedDevice");
            secondaryText = formatText("manageDevices-modalBlockTextTwoTrustedDevice");
            title = formatText("manageDevices-modalBlockTitleTrustedDevice");
            deviceName = device.alias;
            buttonAction = () => {
                this.props.setBlockTrustedDeviceInfo(device);
                this.props.history.push('/myprofile/devices/block');
            }
        }

        this.props.openModal(title, text, secondaryText, buttonText, deviceName, buttonAction, ccExtraInfo, recordLink(DEVICES_BLOCK, DEVICES_INIT));
    };

    renderButton() {
        //<FormattedText value="options"/>
        return (
            <OKButton
                modifier="ghost"
                rightIcon="icon-dropdown-abrir"
                smallRightIcon={true}
            >
                {formatText("manageDevices-options")}
            </OKButton>
        );
    }

    addEnrolDeviceOption = (device) => ({
        handleClick: this.changeEnrolDevice.bind(this, device),
        text: formatText(`manageDevices-${device.trusted ? 'untrustDevice' : 'trustOnDevice'}`)
    });

    addBlockDeviceOption = (device) => ({
        handleClick: () => this.blockDevice(device),
        text: formatText(`manageDevices-${!device.blocked ? 'blockDevice' : 'unblockDevice'}`)
    });

    addForgetDeviceOption = (device) => ({
        handleClick: () => this.changeForgetDevice(device),
        text: formatText(`manageDevices-${!device.forgotten ? 'forgetDevice' : 'rememberDevice'}`)
    });

    getPopoverItems = (device) => {
        return [
            this.enrolDeviceFlagBasedFeatureIsActive() && device.enrol && this.addEnrolDeviceOption(device),
            device.forgotten && !this.deviceHasActiveSession(device) && this.addForgetDeviceOption(device),
            this.addBlockDeviceOption(device)
        ].filter(e => e);
    };

    deviceHasActiveSession(device) {
        return !!(device.sessions && device.sessions[0] && device.sessions[0].active)
    }

    enrolDeviceFlagBasedFeatureIsActive() {
        return !!(this.props.flagBasedFeatures
            && this.props.flagBasedFeatures.get(ENROL_DEVICES));
    }

    render() {
        const {device} = this.props;

        return (
            <PopoverMenu
                target={this.renderButton()}
                items={this.getPopoverItems(device)}
                placement="bottomRight"
            />
        );
    }
}

GridDevicesOptionsButton.propTypes = {
    history: PropTypes.object.isRequired,
    device: PropTypes.object,
    requestInvalidateSession: PropTypes.func,
    requestBlockDevice: PropTypes.func,
    toggleTrustDeviceStatus: PropTypes.func,
    requestForgetDevice: PropTypes.func,
    setBlockTrustedDeviceInfo: PropTypes.func,
    flagBasedFeatures: PropTypes.object.isRequired,
    openModal: PropTypes.func
};

GridDevicesOptionsButton.defaultProps = {
    device: {},
    requestBlockDevice: () => {},
    requestForgetDevice: () => {},
    setBlockTrustedDeviceInfo: () => {},
    openModal: () => null
};

const mapDispatchToProps = {
    requestBlockDevice,
    requestForgetDevice,
    setBlockTrustedDeviceInfo
};

const mapStateToProps = state => ({
    flagBasedFeatures: state.flagBasedFeatures
});


module.exports.constructor = connect(mapStateToProps, mapDispatchToProps)(GridDevicesOptionsButton)
module.exports.GridDevicesOptionsButton = connect(mapStateToProps, mapDispatchToProps)(withRouter(GridDevicesOptionsButton))
